export class CustomBaseStyle {
    HeaderBackground: string;
    HeaderForeground: string;
    Line: string;
    StickyBackground: string;
}
